import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Valikud pole saadaval

  <span style="color:#85c1dc;">**FI:**</span>
  Valinta ei ole saatavana

  <span style="color:#85c1dc;">**RU:**</span>
  Выбор недоступен
*/
/* @__NO_SIDE_EFFECTS__ */
const m1739 = msg(
  mf`Valikud pole saadaval`,
  mf`Valinta ei ole saatavana`,
  mf`Выбор недоступен`,
)

export { m1739 as 'w.module.submission_form.not_available' }